import React, { useState } from 'react';
import {
    DataTable,
    Table,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    TableCell,
    TableContainer,
    TableToolbar,
    TableToolbarContent,
    TableToolbarSearch,
    TableExpandRow,
    TableExpandedRow,
    TableExpandHeader,
    Pagination
} from '@carbon/react';
import Typography from '../Basics/Typography';

const TimeExpansionTable = ({ headers, rows }) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    return (
        <DataTable rows={rows} headers={headers}>
            {({
                rows: carbonRows,
                headers: carbonHeaders,
                getHeaderProps,
                getRowProps,
                getTableProps,
                getTableContainerProps,
                getExpandedRowProps,
                onInputChange,
            }) => (
                <TableContainer
                    {...getTableContainerProps()}
                    style={{
                        backgroundColor: '#161616',
                        color: '#f4f4f4',
                        border: '1px solid #393939',
                        borderRadius: '4px',
                    }}
                >
                    <TableToolbar style={{ backgroundColor: '#161616' }}>
                        <TableToolbarContent>
                            <TableToolbarSearch
                                placeholder="Buscar equipo..."
                                onChange={onInputChange}
                            />
                        </TableToolbarContent>
                    </TableToolbar>

                    <Table {...getTableProps()}>
                        <TableHead>
                            <TableRow>
                                <TableExpandHeader />
                                {carbonHeaders.map((header) => (
                                    <TableHeader
                                        key={header.key}
                                        {...getHeaderProps({ header })}
                                        style={{
                                            backgroundColor: '#262626',
                                            color: '#f4f4f4',
                                            fontWeight: 'bold',
                                            borderBottom: '1px solid #393939',
                                        }}
                                    >
                                        {header.header}
                                    </TableHeader>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {carbonRows
                                .slice((page - 1) * pageSize, page * pageSize)
                                .map((row) => (
                                    <React.Fragment key={row.id}>
                                        <TableExpandRow
                                            {...getRowProps({ row })}
                                            style={{
                                                backgroundColor: '#161616',
                                                color: '#f4f4f4',
                                                borderBottom: '1px solid #393939',
                                            }}
                                        >
                                            {row.cells.map((cell) => {
                                                const value = cell.value;
                                                const isPercentage =
                                                    typeof value === 'string' && value.includes('%');

                                                return (
                                                    <TableCell
                                                        key={cell.id}
                                                        style={{
                                                            color: '#c6c6c6',
                                                            fontSize: '0.85rem',
                                                            verticalAlign: 'middle',
                                                            borderBottom: '1px solid #393939',
                                                        }}
                                                    >
                                                        {isPercentage ? (
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    gap: '0.5rem',
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        flex: 1,
                                                                        height: '6px',
                                                                        backgroundColor: '#262626',
                                                                        borderRadius: '2px',
                                                                        overflow: 'hidden',
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            width: value,
                                                                            height: '100%',
                                                                            backgroundColor: '#08BDBA',
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                                <span
                                                                    style={{
                                                                        fontSize: '0.75rem',
                                                                        color: '#08BDBA',
                                                                        minWidth: '35px',
                                                                        textAlign: 'right',
                                                                    }}
                                                                >
                                                                    {value}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            value
                                                        )}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableExpandRow>

                                        <TableExpandedRow
                                            {...getExpandedRowProps({ row })}
                                            colSpan={carbonHeaders.length + 1}
                                            style={{
                                                backgroundColor: '#1f1f1f',
                                                color: '#f4f4f4',
                                                borderBottom: '1px solid #393939',
                                            }}
                                        >
                                            <div style={{ padding: '1rem' }}>
                                                <Typography
                                                    style={{
                                                        fontWeight: 'bold',
                                                        color: '#08BDBA',
                                                        marginBottom: '0.75rem',
                                                    }}
                                                >
                                                    Detalle del equipo {row.id}
                                                </Typography>

                                                {(() => {
                                                    const original = rows.find((r) => r.id === row.id);
                                                    const detalles = original?.detalles || {};

                                                    return (
                                                        <table
                                                            style={{
                                                                width: '100%',
                                                                color: '#c6c6c6',
                                                                fontSize: '0.85rem',
                                                                borderCollapse: 'collapse',
                                                            }}
                                                        >
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ textAlign: 'left' }}>Tiempo de colación (h)</th>
                                                                    <th style={{ textAlign: 'left' }}>Tiempo en traslado (h)</th>
                                                                    <th style={{ textAlign: 'left' }}>Tiempo detenido (h)</th>
                                                                    <th style={{ textAlign: 'left' }}>Tiempo en carga (h)</th>
                                                                    <th style={{ textAlign: 'left' }}>Tiempo en descarga (h)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>{detalles.colacion ?? '-'}</td>
                                                                    <td>{detalles.traslado ?? '-'}</td>
                                                                    <td>{detalles.detenido ?? '-'}</td>
                                                                    <td>{detalles.carga ?? '-'}</td>
                                                                    <td>{detalles.descarga ?? '-'}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    );
                                                })()}
                                            </div>
                                        </TableExpandedRow>
                                    </React.Fragment>
                                ))}
                        </TableBody>
                    </Table>

                    <Pagination
                        totalItems={rows.length}
                        pageSizes={[5, 10, 15]}
                        itemsPerPageText="Elementos por página"
                        pageRangeText={(current, total) => `${current}–${total} página(s)`}
                        itemRangeText={(min, max) => `${min}–${max} Filas`}
                        pageNumberText="Número de página"
                        page={page}
                        pageSize={pageSize}
                        onChange={({ page, pageSize }) => {
                            setPage(page);
                            setPageSize(pageSize);
                        }}
                        forwardText="Página siguiente"
                        backwardText="Página anterior"
                    />
                </TableContainer>
            )}
        </DataTable>

    );
};

export default TimeExpansionTable;
